import React from "react";
import "./GlobalLoading.css";

export default function GlobalLoading({
  visible = false,
  title = "Gerando PDF",
  subtitle = "Preparando páginas…",
  progress = null,
  onCancel, 
  cancelLabel = "Cancelar",
}) {
  if (!visible) return null;

  const pct =
    typeof progress === "number" && Number.isFinite(progress)
      ? Math.max(0, Math.min(100, Math.round(progress)))
      : null;

  const canCancel = typeof onCancel === "function";

  return (
    <div className="glLoading" role="alert" aria-live="polite">
      <div className="glLoading__backdrop" />

      <div className="glLoading__card">
        <div className="glLoading__shine" aria-hidden="true" />
        <div className="glLoading__grid" aria-hidden="true" />

        <div className="glLoading__top">
          <div className="glLoading__badge">
            <span className="glLoading__dot" />
            <span className="glLoading__badgeText">Processando</span>
          </div>

          <div className="glLoading__pct">{pct !== null ? `${pct}%` : "—"}</div>
        </div>

        <div className="glLoading__texts">
          <div className="glLoading__title">{title}</div>
          <div className="glLoading__subtitle">{subtitle}</div>
        </div>

        <div className="glLoading__bar">
          <div
            className="glLoading__barFill"
            style={{ width: pct !== null ? `${pct}%` : "38%" }}
          />
          <div className="glLoading__barGlow" />
        </div>

        <div className="glLoading__foot">
          <div className="glLoading__hint">
            {pct !== null
              ? "Você pode cancelar a qualquer momento. O cancelamento pode levar alguns segundos para ser concluído."
              : "Aguarde só um instante…"}
          </div>

          <div className="glLoading__actions">
            {canCancel ? (
              <button
                type="button"
                className="glLoading__cancel"
                onClick={onCancel}
              >
                {cancelLabel}
              </button>
            ) : null}

            <div className="glLoading__spinner" aria-hidden="true">
              <span className="glLoading__spinRing" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
